import fonts from "./fonts.json" assert { type: "json" };
const fontDictionary = fonts;
export function resolve(alias) {
    return fontDictionary[alias] || alias;
}
export function resolveTest(alias) {
    return fontDictionary[alias] || `${alias}, wingdings`;
}
export function listFontNames() {
    return Object.keys(fonts);
}
export function listFontStacks() {
    return Object.keys(fonts)
        .map(key => `${key}=${resolve(key)}`)
        .join(";");
}
//# sourceMappingURL=index.js.map
window.define('@lifecare-welfare/document-fonts', [], function() { return __webpack_module__.exports; });